module.exports = __webpack_public_path__ + "static/media/3DPPA26.c30f4b07.jpg";